import { render } from "./ExternalVmsStatus.vue?vue&type=template&id=2a8fda8b&ts=true"
import script from "./ExternalVmsStatus.vue?vue&type=script&lang=ts"
export * from "./ExternalVmsStatus.vue?vue&type=script&lang=ts"

import "./ExternalVmsStatus.vue?vue&type=style&index=0&id=2a8fda8b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__